import React, { useEffect, useState, createElement } from 'react';
import { ArrowRight, CheckCircle2, AlertTriangle, BookOpen, Wrench, Truck, PenTool, Shield, Thermometer, Droplets, Flame, Zap, Sun, Wind, Hammer, Paintbrush, FileCheck, Map, Settings, Gift, Clock, ShieldCheck, Download } from 'lucide-react';
import { PurchasePopup } from '../components/PurchasePopup';
import { TestimonialCard } from '../components/TestimonialCard';
export function SalesPage() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 14,
    seconds: 59
  });
  const [selectedPack, setSelectedPack] = useState<'guia' | 'completo'>('completo');
  useEffect(() => {
    // Meta Pixel initialization
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      ;
      (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          b.head.appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '1264100581525870');
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const scrollToCheckout = () => {
    const element = document.getElementById('purchase-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  return <div className="min-h-screen bg-stone-50 font-sans selection:bg-amber-200 selection:text-stone-900" data-id="element-20">
      <PurchasePopup data-id="element-21" />

      {/* TOP BANNER */}
      <div className="bg-stone-900 text-stone-200 text-center py-1.5 md:py-3 px-3 md:px-4 text-[10px] md:text-sm font-medium leading-tight" data-id="element-22">
        PARA EL QUE SUEÑA CON ARMAR SU PROPIO MOTORHOME Y TODAVÍA NO SABE POR
        DÓNDE EMPEZAR…
      </div>

      {/* HERO SECTION */}
      <header className="pt-1 md:pt-4 pb-0 md:pb-4 px-3 md:px-4 max-w-4xl mx-auto text-center" data-id="element-23">
        <h2 className="text-amber-600 font-bold tracking-wider uppercase text-[9px] md:text-xs mb-0.5 md:mb-2" data-id="element-24">
          La Guía Maestra de Camperización Argentina
        </h2>

        <h1 className="text-[13px] md:text-6xl font-extrabold text-stone-900 mb-1 md:mb-3 leading-tight px-1" data-id="element-25">
          En Argentina se camperiza diferente. Con otros materiales, otras
          normas y otro presupuesto. Esta guía lo sabe.
        </h1>

        {/* Main Product Image */}
        <button onClick={scrollToCheckout} className="w-[65%] md:w-full max-w-xs md:max-w-3xl mx-auto mb-1 md:mb-3 overflow-hidden relative group cursor-pointer transition-transform hover:scale-[1.02]" aria-label="Ir a la sección de compra" data-id="element-26">
          <img src="https://cdn.magicpatterns.com/uploads/7KNWzKGLLXtKgfZWPXr7rs/mock_up_principal_camperizacion-removebg-preview(2).png" alt="La Guía Maestra de Camperización Argentina - Mega Pack" className="w-full h-auto" data-id="element-27" />
        </button>

        <p className="text-stone-500 font-medium uppercase tracking-wide text-[9px] md:text-xs mb-0.5 md:mb-2" data-id="element-28">
          NUEVO — 16 Partes + 4 Bonos · Descarga inmediata
        </p>

        {/* FEATURES LIST */}
        <ul className="text-left space-y-0.5 md:space-y-1.5 text-stone-700 text-[9px] md:text-lg max-w-sm mx-auto mb-1 md:mb-3" data-id="element-29">
          <li className="flex items-start gap-1 md:gap-2" data-id="element-30">
            <CheckCircle2 className="w-2.5 h-2.5 md:w-4 md:h-4 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-31" />
            <span data-id="element-32">560+ páginas del furgón vacío al primer viaje</span>
          </li>
          <li className="flex items-start gap-1 md:gap-2" data-id="element-33">
            <CheckCircle2 className="w-2.5 h-2.5 md:w-4 md:h-4 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-34" />
            <span data-id="element-35">Electricidad, agua, gas, solar, muebles y homologación</span>
          </li>
          <li className="flex items-start gap-1 md:gap-2" data-id="element-36">
            <CheckCircle2 className="w-2.5 h-2.5 md:w-4 md:h-4 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-37" />
            <span data-id="element-38">Sistema paso a paso adaptado 100% a Argentina</span>
          </li>
          <li className="flex items-start gap-1 md:gap-2" data-id="element-39">
            <CheckCircle2 className="w-2.5 h-2.5 md:w-4 md:h-4 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-40" />
            <span data-id="element-41">
              Precios reales, normas reales, materiales que conseguís acá
            </span>
          </li>
          <li className="flex items-start gap-1 md:gap-2" data-id="element-42">
            <CheckCircle2 className="w-2.5 h-2.5 md:w-4 md:h-4 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-43" />
            <span data-id="element-44">
              Cómo construir sin talleres, sin adivinar y sin tirar plata
            </span>
          </li>
          <li className="flex items-start gap-1 md:gap-2" data-id="element-45">
            <CheckCircle2 className="w-2.5 h-2.5 md:w-4 md:h-4 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-46" />
            <span data-id="element-47">Funciona para furgón, minibús y colectivo</span>
          </li>
        </ul>

        <button onClick={scrollToCheckout} className="bg-emerald-500 hover:bg-emerald-400 text-white text-[11px] md:text-xl font-extrabold py-2 md:py-3 px-3 md:px-5 rounded-lg md:rounded-xl shadow-[0_3px_0_rgb(5,150,105)] md:shadow-[0_5px_0_rgb(5,150,105)] hover:shadow-[0_1px_0_rgb(5,150,105)] md:hover:shadow-[0_2px_0_rgb(5,150,105)] hover:translate-y-1 transition-all w-full max-w-sm md:max-w-lg mx-auto flex items-center justify-center gap-1.5 mb-0.5 md:mb-0" data-id="element-48">
          ✅ SÍ, QUIERO LA GUÍA MAESTRA COMPLETA{' '}
          <ArrowRight className="w-3 h-3 md:w-4 md:h-4" data-id="element-49" />
        </button>
        <p className="text-stone-500 font-medium text-[9px] md:text-xs pb-1 md:pb-0 md:mt-2" data-id="element-50">
          Pago único de $19.990 ARS · Acceso inmediato
        </p>
      </header>

      {/* PROBLEM AGITATION */}
      <section className="bg-stone-900 text-stone-300 py-20 px-4" data-id="element-51">
        <div className="max-w-3xl mx-auto space-y-6 text-lg" data-id="element-52">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-53">
            El problema no es que no tenés tiempo ni ganas.
          </h2>

          <p data-id="element-54">
            Si estás pensando en camperizar en Argentina, sabés de qué hablamos.
          </p>

          <p data-id="element-55">
            Llega el fin de semana. Se arma el momento. Abrís YouTube, entrás a
            los grupos de Facebook y en algún punto pasa algo que no se dice en
            voz alta pero todos los que empezaron este camino lo sienten:
          </p>

          <p className="text-xl text-amber-400 font-semibold italic border-l-4 border-amber-500 pl-6 py-2 my-8" data-id="element-56">
            Hay uno que construyó su motorhome. Y hay uno que sigue mirando
            videos.
          </p>

          <p data-id="element-57">
            Y si estás leyendo esto, probablemente en más de un fin de semana
            fuiste el segundo.
          </p>

          <p data-id="element-58">
            Quizás empezaste a investigar con energía. Pero cuando llegás a la
            parte eléctrica, algo se congela. No sabés qué calibre de cable va
            entre la batería y el tablero. No sabés si te conviene AGM o litio.
            Y terminás cerrando la pestaña y diciéndote "la semana que viene
            arranco de verdad".
          </p>

          <p data-id="element-59">
            O peor: arrancás, comprás materiales, instalás algo y después un
            conocido te dice que está mal. Hay que desarmarlo. Hay que volver a
            comprar. Y perdiste tiempo, plata y energía.
          </p>

          <p data-id="element-60">
            O comprás el furgón, lo tenés en el garaje hace seis meses y todavía
            no le tocaste nada porque no querés meter la pata en el primer paso.
          </p>

          <p className="text-white font-bold text-xl mt-8" data-id="element-61">
            Y lo frustrante no es no avanzar. Es no saber exactamente qué te
            está frenando.
          </p>
        </div>
      </section>

      {/* THE REALITY */}
      <section className="py-20 px-4 bg-white" data-id="element-62">
        <div className="max-w-4xl mx-auto" data-id="element-63">
          <h2 className="text-3xl font-bold text-stone-900 mb-12 text-center" data-id="element-64">
            Lo que pasa en la mayoría de los proyectos de camperización en
            Argentina
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-65">
            <div className="bg-stone-50 p-6 rounded-2xl border border-stone-200" data-id="element-66">
              <AlertTriangle className="w-8 h-8 text-amber-500 mb-4" data-id="element-67" />
              <p className="text-stone-700" data-id="element-68">
                Uno aprendió mirando videos europeos donde los materiales, las
                normas y los precios no aplican acá.
              </p>
            </div>
            <div className="bg-stone-50 p-6 rounded-2xl border border-stone-200" data-id="element-69">
              <AlertTriangle className="w-8 h-8 text-amber-500 mb-4" data-id="element-70" />
              <p className="text-stone-700" data-id="element-71">
                Otro sabe "más o menos" pero nunca encontró un sistema ordenado
                que le diga en qué orden hacer cada cosa.
              </p>
            </div>
            <div className="bg-stone-50 p-6 rounded-2xl border border-stone-200" data-id="element-72">
              <AlertTriangle className="w-8 h-8 text-amber-500 mb-4" data-id="element-73" />
              <p className="text-stone-700" data-id="element-74">
                El de los grupos de Facebook pregunta y recibe cinco respuestas
                contradictorias sin saber a cuál creerle.
              </p>
            </div>
            <div className="bg-stone-50 p-6 rounded-2xl border border-stone-200" data-id="element-75">
              <AlertTriangle className="w-8 h-8 text-amber-500 mb-4" data-id="element-76" />
              <p className="text-stone-700" data-id="element-77">
                Todos le tienen miedo a la electricidad y al gas porque nadie se
                los explicó sin tecnicismos.
              </p>
            </div>
            <div className="bg-stone-50 p-6 rounded-2xl border border-stone-200 md:col-span-2" data-id="element-78">
              <AlertTriangle className="w-8 h-8 text-amber-500 mb-4" data-id="element-79" />
              <p className="text-stone-700" data-id="element-80">
                Nadie entiende el proceso de homologación hasta que lo termina
                todo y descubre que algo no cumple la norma.
              </p>
            </div>
          </div>

          <div className="bg-stone-100 p-8 rounded-2xl text-center" data-id="element-81">
            <p className="text-lg text-stone-700 mb-4" data-id="element-82">
              Y encima siempre hay alguien en los grupos que parece que sabe
              algo que los demás no saben. Tiene el motorhome terminado. Lo hizo
              él solo. Viaja todos los fines de semana. Y cuando le preguntás
              cómo lo hizo, te dice "fui aprendiendo de a poco".
            </p>
            <p className="text-2xl font-bold text-stone-900" data-id="element-83">
              Ese constructor no nació sabiendo. Siguió un sistema.
            </p>
          </div>
        </div>
      </section>

      {/* THE 3 REASONS */}
      <section className="py-20 px-4 bg-stone-900 text-stone-300" data-id="element-84">
        <div className="max-w-4xl mx-auto" data-id="element-85">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 text-center" data-id="element-86">
            El cortocircuito real de la camperización argentina
          </h2>
          <p className="text-center text-xl mb-12" data-id="element-87">
            El problema no es la falta de ganas ni el presupuesto. El proyecto
            se frena por tres razones concretas:
          </p>

          <div className="space-y-8" data-id="element-88">
            <div className="bg-stone-800 p-8 rounded-2xl border border-stone-700" data-id="element-89">
              <h3 className="text-xl font-bold text-amber-400 mb-4" data-id="element-90">
                Razón 1: No existe un sistema ordenado adaptado a Argentina.
              </h3>
              <p data-id="element-91">
                Todo lo que hay disponible está hecho para Europa o
                Norteamérica. Materiales que no conseguís, normas que no
                aplican, precios en monedas que no son las tuyas. Traducir esa
                información al contexto argentino requiere cientos de horas que
                la mayoría no tiene.
              </p>
            </div>

            <div className="bg-stone-800 p-8 rounded-2xl border border-stone-700" data-id="element-92">
              <h3 className="text-xl font-bold text-amber-400 mb-4" data-id="element-93">
                Razón 2: El miedo a cometer errores caros.
              </h3>
              <p data-id="element-94">
                En un proyecto de varios millones de pesos, cada decisión
                equivocada tiene consecuencias reales. Un cable del calibre
                incorrecto que se calienta. Una instalación de gas que el
                gasista te pide desarmár. Una aislación mal ejecutada que genera
                condensación dentro de los muebles. Estos errores no son solo
                técnicos: son económicos y emocionales.
              </p>
            </div>

            <div className="bg-stone-800 p-8 rounded-2xl border border-stone-700" data-id="element-95">
              <h3 className="text-xl font-bold text-amber-400 mb-4" data-id="element-96">
                Razón 3: La falta de un interlocutor que te acompañe.
              </h3>
              <p data-id="element-97">
                Los grupos de Facebook son caóticos. YouTube es fragmentado. Los
                talleres cobran por trabajar, no por enseñarte. Y el resultado
                es que cada decisión del proyecto la tomás solo, con la
                información que pudiste juntar, rezando para que esté bien.
              </p>
            </div>
          </div>

          <div className="text-center mt-12" data-id="element-98">
            <p className="text-xl mb-2" data-id="element-99">
              No es falta de capacidad. No es mala suerte.
            </p>
            <p className="text-2xl font-bold text-white mb-10" data-id="element-100">
              Es falta de un sistema que funcione de verdad para Argentina.
            </p>

            <button onClick={scrollToCheckout} className="bg-emerald-500 hover:bg-emerald-400 text-white text-lg font-extrabold py-4 px-8 rounded-xl shadow-[0_6px_0_rgb(5,150,105)] hover:shadow-[0_3px_0_rgb(5,150,105)] hover:translate-y-1 transition-all inline-flex items-center justify-center gap-3" data-id="element-101">
              🔥 QUIERO DEJAR DE POSTERGAR — MOSTRAME EL SISTEMA{' '}
              <ArrowRight className="w-5 h-5" data-id="element-102" />
            </button>
          </div>
        </div>
      </section>

      {/* THE SOLUTION */}
      <section className="py-24 px-4 bg-white text-center" data-id="element-103">
        <div className="max-w-4xl mx-auto" data-id="element-104">
          <h2 className="text-amber-600 font-bold tracking-widest uppercase text-sm mb-4" data-id="element-105">
            LA SOLUCIÓN
          </h2>
          <h3 className="text-4xl md:text-5xl font-extrabold text-stone-900 mb-8" data-id="element-106">
            LA GUÍA MAESTRA DE CAMPERIZACIÓN ARGENTINA™
          </h3>

          <p className="text-2xl text-stone-700 font-medium mb-8" data-id="element-107">
            El sistema completo para construir tu motorhome en Argentina desde
            cero.
          </p>

          <p className="text-xl text-stone-600 mb-12 max-w-3xl mx-auto" data-id="element-108">
            Sin adivinar. Sin depender de talleres que no explican nada. Sin
            perder plata en errores que se podían evitar.
          </p>

          <div className="bg-stone-50 p-8 md:p-12 rounded-3xl border border-stone-200 text-left mb-12" data-id="element-109">
            <p className="text-lg text-stone-700 mb-6" data-id="element-110">
              Todo el sistema ya está escrito, organizado y listo para aplicar
              desde el primer fin de semana. Creado por alguien que estudió la
              camperización argentina como lo que es: un proyecto de ingeniería
              con contexto local, no una traducción de contenido extranjero.
            </p>
            <p className="text-lg text-stone-700 mb-8" data-id="element-111">
              El <strong data-id="element-112">Método de Construcción Secuencial</strong> nació de
              años de analizar proyectos de camperización en Argentina, entender
              qué separa al que termina su motorhome del que lo posterga
              indefinidamente, y convertir cada decisión técnica en un proceso
              claro y replicable.
            </p>
            <blockquote className="border-l-4 border-amber-500 pl-6 py-2 italic text-xl text-stone-800 font-medium" data-id="element-113">
              "Diseñé este sistema porque en Argentina no existía una guía que
              respetara nuestros materiales, nuestras normas y nuestros precios.
              Todo lo que está acá lo aprendí de la manera difícil para que vos
              no tengas que hacerlo."
            </blockquote>
          </div>
        </div>
      </section>

      {/* QUÉ TE LLEVÁS HOY */}
      <section className="py-20 px-4 bg-stone-100" data-id="element-114">
        <div className="max-w-4xl mx-auto" data-id="element-115">
          <h2 className="text-4xl font-bold text-stone-900 mb-16 text-center" data-id="element-116">
            QUÉ TE LLEVÁS HOY
          </h2>

          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-stone-200 mb-16" data-id="element-117">
            <h3 className="text-2xl font-bold text-stone-900 mb-6" data-id="element-118">
              El Mecanismo Central: El Método de Construcción Secuencial
            </h3>
            <p className="text-lg text-stone-700 mb-6" data-id="element-119">
              El error más común del constructor principiante es creer que el
              motorhome se construye por intuición o por videos sueltos de
              YouTube.
            </p>
            <p className="text-lg text-stone-700 mb-6" data-id="element-120">
              El <strong data-id="element-121">Método de Construcción Secuencial</strong> es el
              sistema que atraviesa las 16 partes de la guía y cambia para
              siempre cómo encarás el proyecto: el motorhome no se construye con
              herramientas, se construye con{' '}
              <strong data-id="element-122">decisiones correctas en el orden correcto.</strong>
            </p>
            <p className="text-lg text-stone-700 mb-6" data-id="element-123">
              El mismo criterio de planificación que usás en la Parte 4 para
              diseñar el interior es el que te permite ejecutar la Parte 12 sin
              tener que desarmár nada. El mismo sistema de seguridad del Parte 8
              para el gas es el que el ingeniero certificador va a verificar en
              la Parte 14 cuando llegue el momento de homologar.
            </p>
            <p className="text-xl font-bold text-stone-900 mb-6" data-id="element-124">
              Un solo sistema. En todas las fases. Para siempre.
            </p>
            <p className="text-lg text-stone-700" data-id="element-125">
              Eso no es un detalle. Es la razón por la que este sistema funciona
              cuando el resto no funciona.
            </p>
          </div>

          <h3 className="text-3xl font-bold text-stone-900 mb-4 text-center" data-id="element-126">
            El Sistema Paso a Paso
          </h3>
          <p className="text-xl text-stone-600 text-center mb-12" data-id="element-127">
            16 partes diseñadas para llevarte del furgón vacío al primer viaje.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-128">
            {/* PARTE 1 */}
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-stone-200" data-id="element-129">
              <div className="flex items-center gap-3 mb-4" data-id="element-130">
                <BookOpen className="w-6 h-6 text-amber-500" data-id="element-131" />
                <h4 className="text-xl font-bold text-stone-900" data-id="element-132">
                  📘 PARTE 1: Los Fundamentos
                </h4>
              </div>
              <p className="text-stone-900 font-medium mb-4" data-id="element-133">
                Por Qué el 80% de los Proyectos se Frena Antes de Empezar
              </p>
              <p className="text-stone-600 mb-4 italic" data-id="element-134">
                El punto de partida real. Antes de construir, entender el
                proyecto completo.
              </p>
              <ul className="space-y-2 text-stone-700 ml-4 list-disc marker:text-amber-500" data-id="element-135">
                <li data-id="element-136">Qué es una camperización y qué no es</li>
                <li data-id="element-137">
                  Los 4 tipos de proyecto y cuál es el correcto para tu
                  situación
                </li>
                <li data-id="element-138">Cómo funciona el Método de Construcción Secuencial</li>
                <li data-id="element-139">El peso total y cómo calcularlo antes de gastar un peso</li>
                <li data-id="element-140">Por qué el orden de las fases no es negociable</li>
                <li data-id="element-141">
                  Los 10 errores del principiante y cómo evitarlos desde el
                  primer día
                </li>
              </ul>
            </div>

            {/* PARTE 2 */}
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-stone-200" data-id="element-142">
              <div className="flex items-center gap-3 mb-4" data-id="element-143">
                <Wrench className="w-6 h-6 text-amber-500" data-id="element-144" />
                <h4 className="text-xl font-bold text-stone-900" data-id="element-145">
                  📘 PARTE 2: Herramientas y Materiales
                </h4>
              </div>
              <p className="text-stone-900 font-medium mb-4" data-id="element-146">
                Lo que Comprás Antes de Empezar
              </p>
              <p className="text-stone-600 mb-4 italic" data-id="element-147">
                El inventario real de lo que necesitás y lo que el marketing te
                hace creer que necesitás.
              </p>
              <ul className="space-y-2 text-stone-700 ml-4 list-disc marker:text-amber-500" data-id="element-148">
                <li data-id="element-149">
                  Las herramientas mínimas indispensables para una camperización
                  completa
                </li>
                <li data-id="element-150">
                  Las herramientas que podés alquilar o pedir prestadas (y
                  cuándo)
                </li>
                <li data-id="element-151">
                  Los materiales de base: fenólico, aluminio, selladores y
                  adhesivos
                </li>
                <li data-id="element-152">
                  Dónde comprar en Argentina: Warnes, Once, corralones y Mercado
                  Libre
                </li>
                <li data-id="element-153">
                  Cómo leer una ficha técnica de material para no comprar lo
                  incorrecto
                </li>
              </ul>
            </div>

            {/* PARTE 3 */}
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-stone-200" data-id="element-154">
              <div className="flex items-center gap-3 mb-4" data-id="element-155">
                <Truck className="w-6 h-6 text-amber-500" data-id="element-156" />
                <h4 className="text-xl font-bold text-stone-900" data-id="element-157">
                  📘 PARTE 3: Elección del Vehículo
                </h4>
              </div>
              <p className="text-stone-900 font-medium mb-4" data-id="element-158">
                La Decisión que Define Todo lo Demás
              </p>
              <p className="text-stone-600 mb-4 italic" data-id="element-159">
                Cómo no equivocarte en la compra más importante del proyecto.
              </p>
              <ul className="space-y-2 text-stone-700 ml-4 list-disc marker:text-amber-500" data-id="element-160">
                <li data-id="element-161">
                  Sprinter vs. Master vs. minibús vs. colectivo: la comparativa
                  real con números argentinos
                </li>
                <li data-id="element-162">
                  Los 21 puntos de inspección antes de comprar cualquier
                  vehículo usado
                </li>
                <li data-id="element-163">
                  Cómo detectar óxido oculto, estructura comprometida y chapa
                  reparada con masilla
                </li>
                <li data-id="element-164">
                  El precio real de cada tipo de vehículo en el mercado
                  argentino 2024
                </li>
                <li data-id="element-165">
                  Cómo negociar el precio usando los defectos técnicos como
                  argumento
                </li>
              </ul>
            </div>

            {/* PARTE 4 */}
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-stone-200" data-id="element-166">
              <div className="flex items-center gap-3 mb-4" data-id="element-167">
                <PenTool className="w-6 h-6 text-amber-500" data-id="element-168" />
                <h4 className="text-xl font-bold text-stone-900" data-id="element-169">
                  📘 PARTE 4: Planificación y Diseño Interior
                </h4>
              </div>
              <p className="text-stone-900 font-medium mb-4" data-id="element-170">
                El Plano que te Ahorra Meses de Retrabajo
              </p>
              <p className="text-stone-600 mb-4 italic" data-id="element-171">
                La fase más ignorada y la más importante del proyecto.
              </p>
              <ul className="space-y-2 text-stone-700 ml-4 list-disc marker:text-amber-500" data-id="element-172">
                <li data-id="element-173">
                  Cómo dibujar el layout de tu interior a escala sin saber
                  dibujo técnico
                </li>
                <li data-id="element-174">
                  Los 5 layouts más usados en Argentina con sus ventajas y
                  desventajas reales
                </li>
                <li data-id="element-175">
                  Ergonomía camper: las alturas, anchos y espacios que hacen la
                  diferencia entre cómodo e inhabitable
                </li>
                <li data-id="element-176">
                  Cómo planificar el recorrido de cables y cañerías ANTES de
                  aislar
                </li>
                <li data-id="element-177">
                  El método de "caja de cartón" para probar el diseño antes de
                  cortar madera
                </li>
              </ul>
            </div>

            {/* PARTE 5 */}
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-stone-200" data-id="element-178">
              <div className="flex items-center gap-3 mb-4" data-id="element-179">
                <Shield className="w-6 h-6 text-amber-500" data-id="element-180" />
                <h4 className="text-xl font-bold text-stone-900" data-id="element-181">
                  📘 PARTE 5: Preparación del Vehículo
                </h4>
              </div>
              <p className="text-stone-900 font-medium mb-4" data-id="element-182">
                La Base que Determina si el Proyecto Dura 5 o 50 Años
              </p>
              <p className="text-stone-600 mb-4 italic" data-id="element-183">
                El trabajo invisible que el 90% subestima y que define la
                longevidad de todo.
              </p>
              <ul className="space-y-2 text-stone-700 ml-4 list-disc marker:text-amber-500" data-id="element-184">
                <li data-id="element-185">
                  El sistema de 3 capas anticorrosivas que los talleres
                  profesionales usan
                </li>
                <li data-id="element-186">
                  Cómo tratar el óxido existente sin que vuelva a los 6 meses
                </li>
                <li data-id="element-187">
                  Qué hacer con los orificios, juntas y canales de agua
                  originales
                </li>
                <li data-id="element-188">
                  El tratamiento de cavidades para los perfiles huecos del
                  chasis
                </li>
                <li data-id="element-189">
                  Qué piezas desmontar y cuáles dejar para no complicar la
                  reconstrucción
                </li>
              </ul>
            </div>

            {/* PARTE 6 */}
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-stone-200" data-id="element-190">
              <div className="flex items-center gap-3 mb-4" data-id="element-191">
                <Thermometer className="w-6 h-6 text-amber-500" data-id="element-192" />
                <h4 className="text-xl font-bold text-stone-900" data-id="element-193">
                  📘 PARTE 6: Aislación Térmica y Acústica
                </h4>
              </div>
              <p className="text-stone-900 font-medium mb-4" data-id="element-194">
                El Secreto del Confort que Nadie Ve Pero Todos Sienten
              </p>
              <p className="text-stone-600 mb-4 italic" data-id="element-195">
                La inversión más importante del interior. La más difícil de
                corregir si se hace mal.
              </p>
              <ul className="space-y-2 text-stone-700 ml-4 list-disc marker:text-amber-500" data-id="element-196">
                <li data-id="element-197">
                  Kaiflex, XPS y lana mineral: diferencias reales y cuándo usar
                  cada uno
                </li>
                <li data-id="element-198">
                  Cómo calcular el espesor correcto para tu clima de viaje
                  principal
                </li>
                <li data-id="element-199">
                  El sistema de instalación que elimina los puentes térmicos de
                  las costillas
                </li>
                <li data-id="element-200">
                  Condensación: por qué aparece, cómo prevenirla y qué destruye
                  si no la controlás
                </li>
                <li data-id="element-201">
                  Aislación acústica del piso: el material que transforma el
                  ruido de chapa en silencio
                </li>
              </ul>
            </div>

            {/* PARTE 7 */}
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-stone-200" data-id="element-202">
              <div className="flex items-center gap-3 mb-4" data-id="element-203">
                <Droplets className="w-6 h-6 text-amber-500" data-id="element-204" />
                <h4 className="text-xl font-bold text-stone-900" data-id="element-205">
                  📘 PARTE 7: Sistema de Agua
                </h4>
              </div>
              <p className="text-stone-900 font-medium mb-4" data-id="element-206">
                Del Tanque a la Ducha sin Fugas y sin Olores
              </p>
              <p className="text-stone-600 mb-4 italic" data-id="element-207">
                El circuito completo de agua limpia, agua caliente, grises y
                negras.
              </p>
              <ul className="space-y-2 text-stone-700 ml-4 list-disc marker:text-amber-500" data-id="element-208">
                <li data-id="element-209">
                  Cómo dimensionar el tanque según tu uso real y cuántos días de
                  autonomía querés
                </li>
                <li data-id="element-210">
                  Bombas de agua: las diferencias reales entre modelos y cuál
                  elegir
                </li>
                <li data-id="element-211">
                  PEX vs. PVC: el material correcto para cada tramo del circuito
                </li>
                <li data-id="element-212">
                  El sistema de aguas grises que no genera olores ni
                  obstrucciones
                </li>
                <li data-id="element-213">
                  Las opciones de inodoro para motorhomes en Argentina con
                  costos reales
                </li>
              </ul>
            </div>

            {/* PARTE 8 */}
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-stone-200" data-id="element-214">
              <div className="flex items-center gap-3 mb-4" data-id="element-215">
                <Flame className="w-6 h-6 text-amber-500" data-id="element-216" />
                <h4 className="text-xl font-bold text-stone-900" data-id="element-217">
                  📘 PARTE 8: Instalación de Gas
                </h4>
              </div>
              <p className="text-stone-900 font-medium mb-4" data-id="element-218">
                El Sistema que Más Respeto Merece
              </p>
              <p className="text-stone-600 mb-4 italic" data-id="element-219">
                Todo bajo norma ENARGAS y NAG 319 para que el gasista firme sin
                retrabajo.
              </p>
              <ul className="space-y-2 text-stone-700 ml-4 list-disc marker:text-amber-500" data-id="element-220">
                <li data-id="element-221">
                  El compartimento de gas que cumple la norma: ventilación,
                  drenaje y materiales
                </li>
                <li data-id="element-222">
                  Cañerías de cobre y mangueras certificadas: diferencias y
                  cuándo usar cada una
                </li>
                <li data-id="element-223">
                  El regulador correcto según los equipos que vas a conectar
                </li>
                <li data-id="element-224">
                  La prueba de estanqueidad paso a paso que no podés saltear
                </li>
                <li data-id="element-225">
                  Qué verifica el gasista matriculado y cómo prepararte para la
                  certificación
                </li>
              </ul>
            </div>

            {/* PARTE 9 */}
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-stone-200" data-id="element-226">
              <div className="flex items-center gap-3 mb-4" data-id="element-227">
                <Zap className="w-6 h-6 text-amber-500" data-id="element-228" />
                <h4 className="text-xl font-bold text-stone-900" data-id="element-229">
                  📘 PARTE 9: Sistema Eléctrico
                </h4>
              </div>
              <p className="text-stone-900 font-medium mb-4" data-id="element-230">
                El Cerebro del Motorhome
              </p>
              <p className="text-stone-600 mb-4 italic" data-id="element-231">
                El sistema que más miedo da y el que más libertad da cuando está
                bien hecho.
              </p>
              <ul className="space-y-2 text-stone-700 ml-4 list-disc marker:text-amber-500" data-id="element-232">
                <li data-id="element-233">
                  Cómo calcular el consumo diario real de todos tus equipos
                </li>
                <li data-id="element-234">
                  AGM vs. Gel vs. Litio: la comparativa real con números
                  argentinos
                </li>
                <li data-id="element-235">
                  Calibres de cable: la tabla completa para no subdimensionar
                  nada
                </li>
                <li data-id="element-236">
                  El tablero de distribución con fusibles individuales por
                  circuito
                </li>
                <li data-id="element-237">
                  Inversor y cargador: cómo elegirlos e instalarlos
                  correctamente
                </li>
              </ul>
            </div>

            {/* PARTE 10 */}
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-stone-200" data-id="element-238">
              <div className="flex items-center gap-3 mb-4" data-id="element-239">
                <Sun className="w-6 h-6 text-amber-500" data-id="element-240" />
                <h4 className="text-xl font-bold text-stone-900" data-id="element-241">
                  📘 PARTE 10: Energía Solar
                </h4>
              </div>
              <p className="text-stone-900 font-medium mb-4" data-id="element-242">
                La Fuente que Cambia Todo
              </p>
              <p className="text-stone-600 mb-4 italic" data-id="element-243">
                Silenciosa, gratuita e inagotable. El sistema que te da
                autonomía real.
              </p>
              <ul className="space-y-2 text-stone-700 ml-4 list-disc marker:text-amber-500" data-id="element-244">
                <li data-id="element-245">
                  Cómo calcular exactamente cuántos paneles necesitás para tu
                  consumo real
                </li>
                <li data-id="element-246">
                  Controladores PWM vs. MPPT: la diferencia en números reales
                </li>
                <li data-id="element-247">
                  Instalación en el techo: fijaciones, sellado y ventilación
                  correcta
                </li>
                <li data-id="element-248">
                  Configuración del MPPT para AGM, Gel y Litio con valores
                  exactos
                </li>
                <li data-id="element-249">
                  Monitoreo en tiempo real: cómo saber siempre el estado real de
                  tus baterías
                </li>
              </ul>
            </div>

            {/* PARTE 11 */}
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-stone-200" data-id="element-250">
              <div className="flex items-center gap-3 mb-4" data-id="element-251">
                <Wind className="w-6 h-6 text-amber-500" data-id="element-252" />
                <h4 className="text-xl font-bold text-stone-900" data-id="element-253">
                  📘 PARTE 11: Sistemas de Calefacción
                </h4>
              </div>
              <p className="text-stone-900 font-medium mb-4" data-id="element-254">
                Porque el Frío Patagónico No Perdona
              </p>
              <p className="text-stone-600 mb-4 italic" data-id="element-255">
                La comparativa honesta para que elijas el sistema correcto para
                tu uso real.
              </p>
              <ul className="space-y-2 text-stone-700 ml-4 list-disc marker:text-amber-500" data-id="element-256">
                <li data-id="element-257">
                  Calefacción a gas de tiro balanceado: instalación y
                  certificación
                </li>
                <li data-id="element-258">
                  Calefacción diesel: cómo funciona, modelos disponibles y
                  configuración
                </li>
                <li data-id="element-259">
                  Salamandra a leña: las ventajas reales y las limitaciones que
                  nadie dice
                </li>
                <li data-id="element-260">
                  El cálculo de potencia necesaria para tu vehículo y tu clima
                </li>
                <li data-id="element-261">
                  Ventilación cruzada y control de humedad: el complemento
                  indispensable
                </li>
              </ul>
            </div>

            {/* PARTE 12 */}
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-stone-200" data-id="element-262">
              <div className="flex items-center gap-3 mb-4" data-id="element-263">
                <Hammer className="w-6 h-6 text-amber-500" data-id="element-264" />
                <h4 className="text-xl font-bold text-stone-900" data-id="element-265">
                  📘 PARTE 12: Construcción Interior
                </h4>
              </div>
              <p className="text-stone-900 font-medium mb-4" data-id="element-266">
                Donde el Furgón se Convierte en Hogar
              </p>
              <p className="text-stone-600 mb-4 italic" data-id="element-267">
                Muebles, cocina, baño, cama y almacenamiento con criterio de
                ruta.
              </p>
              <ul className="space-y-2 text-stone-700 ml-4 list-disc marker:text-amber-500" data-id="element-268">
                <li data-id="element-269">
                  Los 6 requisitos únicos de los muebles de motorhome que los
                  diferencian de los domésticos
                </li>
                <li data-id="element-270">
                  Construcción del mueble de cocina paso a paso con lista de
                  corte incluida
                </li>
                <li data-id="element-271">
                  El baño húmedo: la solución más eficiente para espacios
                  reducidos
                </li>
                <li data-id="element-272">
                  Camas fijas, ocultables y convertibles: cómo construir cada
                  tipo
                </li>
                <li data-id="element-273">
                  Almacenamiento inteligente: cómo aprovechar cada centímetro
                  cúbico disponible
                </li>
              </ul>
            </div>

            {/* PARTE 13 */}
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-stone-200" data-id="element-274">
              <div className="flex items-center gap-3 mb-4" data-id="element-275">
                <Paintbrush className="w-6 h-6 text-amber-500" data-id="element-276" />
                <h4 className="text-xl font-bold text-stone-900" data-id="element-277">
                  📘 PARTE 13: Terminaciones
                </h4>
              </div>
              <p className="text-stone-900 font-medium mb-4" data-id="element-278">
                El Detalle que Convierte un Proyecto en un Motorhome de Verdad
              </p>
              <p className="text-stone-600 mb-4 italic" data-id="element-279">
                Lo que ven todos y lo que define la percepción de calidad del
                trabajo.
              </p>
              <ul className="space-y-2 text-stone-700 ml-4 list-disc marker:text-amber-500" data-id="element-280">
                <li data-id="element-281">
                  Pisos vinílicos LVP y SPC: instalación correcta con junta de
                  expansión
                </li>
                <li data-id="element-282">
                  Revestimientos de paredes: ACM, PVC y tapizado con materiales
                  aptos para humedad
                </li>
                <li data-id="element-283">
                  El falso techo: cómo construirlo para que no vibre ni haga
                  ruido en la ruta
                </li>
                <li data-id="element-284">
                  Iluminación LED de 12v: diseño de circuitos y temperaturas de
                  color
                </li>
                <li data-id="element-285">
                  Los detalles finales que elevan el proyecto de bueno a
                  extraordinario
                </li>
              </ul>
            </div>

            {/* PARTE 14 */}
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-stone-200" data-id="element-286">
              <div className="flex items-center gap-3 mb-4" data-id="element-287">
                <FileCheck className="w-6 h-6 text-amber-500" data-id="element-288" />
                <h4 className="text-xl font-bold text-stone-900" data-id="element-289">
                  📘 PARTE 14: Legalización y Homologación
                </h4>
              </div>
              <p className="text-stone-900 font-medium mb-4" data-id="element-290">
                El Trámite que Convierte tu Construcción en un Vehículo Legal
              </p>
              <p className="text-stone-600 mb-4 italic" data-id="element-291">
                El proceso completo para circular como motorhome en Argentina
                sin sorpresas.
              </p>
              <ul className="space-y-2 text-stone-700 ml-4 list-disc marker:text-amber-500" data-id="element-292">
                <li data-id="element-293">
                  El proceso de homologación paso a paso con los organismos
                  reales de Argentina
                </li>
                <li data-id="element-294">
                  Qué documenta el ingeniero certificador y cómo prepararte para
                  la inspección
                </li>
                <li data-id="element-295">
                  Los errores más comunes que hacen fracasar la homologación
                </li>
                <li data-id="element-296">
                  Cambio de categoría en la DNRPA: documentación y costos reales
                </li>
                <li data-id="element-297">Legislación para viajes a Chile, Brasil y España</li>
              </ul>
            </div>

            {/* PARTE 15 */}
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-stone-200" data-id="element-298">
              <div className="flex items-center gap-3 mb-4" data-id="element-299">
                <Map className="w-6 h-6 text-amber-500" data-id="element-300" />
                <h4 className="text-xl font-bold text-stone-900" data-id="element-301">
                  📘 PARTE 15: Pruebas y Viaje Inicial
                </h4>
              </div>
              <p className="text-stone-900 font-medium mb-4" data-id="element-302">
                El Momento de la Verdad
              </p>
              <p className="text-stone-600 mb-4 italic" data-id="element-303">
                Cómo verificar que todo funciona antes de estar a 500km de tu
                casa.
              </p>
              <ul className="space-y-2 text-stone-700 ml-4 list-disc marker:text-amber-500" data-id="element-304">
                <li data-id="element-305">La secuencia correcta de pruebas para cada sistema</li>
                <li data-id="element-306">
                  El viaje de prueba: qué observar, qué registrar y cómo
                  interpretar los resultados
                </li>
                <li data-id="element-307">
                  Los problemas más comunes en el primer viaje y cómo
                  resolverlos
                </li>
                <li data-id="element-308">
                  El protocolo de correcciones antes del primer viaje real
                </li>
              </ul>
            </div>

            {/* PARTE 16 */}
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-stone-200" data-id="element-309">
              <div className="flex items-center gap-3 mb-4" data-id="element-310">
                <Settings className="w-6 h-6 text-amber-500" data-id="element-311" />
                <h4 className="text-xl font-bold text-stone-900" data-id="element-312">
                  📘 PARTE 16: Mantenimiento del Motorhome
                </h4>
              </div>
              <p className="text-stone-900 font-medium mb-4" data-id="element-313">
                El Cuidado que Determina si el Proyecto Dura 5 o 50 Años
              </p>
              <p className="text-stone-600 mb-4 italic" data-id="element-314">
                El calendario que nunca debería saltarse.
              </p>
              <ul className="space-y-2 text-stone-700 ml-4 list-disc marker:text-amber-500" data-id="element-315">
                <li data-id="element-316">Mantenimiento anual de los 4 sistemas principales</li>
                <li data-id="element-317">
                  La inspección bianual con profesionales que extiende la vida
                  útil de todo
                </li>
                <li data-id="element-318">Preparación específica para viajes largos</li>
                <li data-id="element-319">
                  El kit de herramientas y repuestos que nunca pueden faltar a
                  bordo
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES */}
      <section className="py-24 px-4 bg-stone-900 text-stone-200" data-id="element-320">
        <div className="max-w-4xl mx-auto" data-id="element-321">
          <div className="text-center mb-16" data-id="element-322">
            <Gift className="w-16 h-16 text-amber-500 mx-auto mb-6" data-id="element-323" />
            <h2 className="text-4xl font-bold text-white mb-4" data-id="element-324">
              🎁 4 BONOS INCLUIDOS HOY
            </h2>
            <p className="text-xl text-stone-400" data-id="element-325">
              Complementos estratégicos para acelerar tu proyecto.
            </p>
          </div>

          <div className="space-y-8" data-id="element-326">
            {/* Bono 1 */}
            <button onClick={scrollToCheckout} className="w-full text-left bg-stone-800 p-8 rounded-3xl border border-stone-700 hover:border-amber-500 transition-colors group cursor-pointer" data-id="element-327">
              <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-328">
                <div className="w-full md:w-1/3 aspect-square rounded-2xl flex items-center justify-center relative overflow-hidden bg-stone-700" data-id="element-329">
                  <img src="https://cdn.magicpatterns.com/uploads/smGce795SgrCfQn6kfHNMT/bono_1motorhome.png" alt="Bono 1: Lista Maestra de Materiales" className="w-full h-full object-contain" data-id="element-330" />
                </div>
                <div className="w-full md:w-2/3" data-id="element-331">
                  <h3 className="text-2xl font-bold text-white mb-2" data-id="element-332">
                    🎁 Bono #1: Lista Maestra de Materiales con Precios
                    Argentina 2026 (EL MÁS PEDIDO)
                  </h3>
                  <p className="text-stone-400 mb-4" data-id="element-333">
                    164 materiales organizados por fase de construcción con
                    precios de referencia actualizados al mercado argentino.
                    Dónde comprar cada cosa en Mercado Libre, Warnes, Once y
                    corralones del interior. El presupuesto completo de tu
                    proyecto antes de gastar el primer peso.
                  </p>
                  <p className="text-amber-400 font-medium mb-4" data-id="element-334">
                    Para que nunca más te sorprendan los costos reales en el
                    medio del proyecto.
                  </p>
                  <p className="font-bold text-white text-xl" data-id="element-335">¡GRATIS HOY!</p>
                </div>
              </div>
            </button>

            {/* Bono 2 */}
            <button onClick={scrollToCheckout} className="w-full text-left bg-stone-800 p-8 rounded-3xl border border-stone-700 hover:border-amber-500 transition-colors group cursor-pointer" data-id="element-336">
              <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-337">
                <div className="w-full md:w-1/3 aspect-square rounded-2xl flex items-center justify-center relative overflow-hidden bg-stone-700" data-id="element-338">
                  <img src="https://cdn.magicpatterns.com/uploads/rqFBhoMvkPB1vXCvTLriXn/bono_2_motorhome.png" alt="Bono 2: Tablas Eléctricas de Referencia" className="w-full h-full object-contain" data-id="element-339" />
                </div>
                <div className="w-full md:w-2/3" data-id="element-340">
                  <h3 className="text-2xl font-bold text-white mb-2" data-id="element-341">
                    🎁 Bono #2: Tablas Eléctricas de Referencia Completas
                  </h3>
                  <p className="text-stone-400 mb-4" data-id="element-342">
                    14 tablas técnicas para consultar durante toda la
                    instalación eléctrica. Calibres de cable por corriente y
                    distancia, tipos de fusibles por aplicación, voltajes de
                    batería por estado de carga, consumos de equipos típicos y
                    fórmulas de uso frecuente con ejemplos resueltos.
                  </p>
                  <p className="text-amber-400 font-medium mb-4" data-id="element-343">
                    Para que tengas la respuesta técnica exacta en el momento
                    exacto que la necesitás.
                  </p>
                  <p className="font-bold text-white text-xl" data-id="element-344">¡GRATIS HOY!</p>
                </div>
              </div>
            </button>

            {/* Bono 3 */}
            <button onClick={scrollToCheckout} className="w-full text-left bg-stone-800 p-8 rounded-3xl border border-stone-700 hover:border-amber-500 transition-colors group cursor-pointer" data-id="element-345">
              <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-346">
                <div className="w-full md:w-1/3 aspect-square rounded-2xl flex items-center justify-center relative overflow-hidden bg-stone-700" data-id="element-347">
                  <img src="https://cdn.magicpatterns.com/uploads/6VyWWu4Q5EeXXaCBRMb7Yp/bono_3_motorhome.png" alt="Bono 3: Calculadora Solar" className="w-full h-full object-contain" data-id="element-348" />
                </div>
                <div className="w-full md:w-2/3" data-id="element-349">
                  <h3 className="text-2xl font-bold text-white mb-2" data-id="element-350">
                    🎁 Bono #3: Calculadora Solar Paso a Paso con 3 Ejemplos
                    Reales Resueltos
                  </h3>
                  <p className="text-stone-400 mb-4" data-id="element-351">
                    El cálculo completo de sistemas solares para Sprinter de
                    pareja, minibús familiar y colectivo de expedición en
                    Patagonia. Más la planilla en blanco para completar con tus
                    datos y saber exactamente cuántos paneles, qué banco de
                    baterías y qué controlador necesitás antes de gastar un
                    peso.
                  </p>
                  <p className="text-amber-400 font-medium mb-4" data-id="element-352">
                    Para que no adivines el sistema solar y no tengas que
                    comprarlo dos veces.
                  </p>
                  <p className="font-bold text-white text-xl" data-id="element-353">¡GRATIS HOY!</p>
                </div>
              </div>
            </button>

            {/* Bono 4 */}
            <button onClick={scrollToCheckout} className="w-full text-left bg-stone-800 p-8 rounded-3xl border border-stone-700 hover:border-amber-500 transition-colors group cursor-pointer" data-id="element-354">
              <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-355">
                <div className="w-full md:w-1/3 aspect-square rounded-2xl flex items-center justify-center relative overflow-hidden bg-stone-700" data-id="element-356">
                  <img src="https://cdn.magicpatterns.com/uploads/ioXPeuuUsmrXdcKEEqqXdm/bono_4_motorhome.png" alt="Bono 4: Checklists de Obra" className="w-full h-full object-contain" data-id="element-357" />
                </div>
                <div className="w-full md:w-2/3" data-id="element-358">
                  <h3 className="text-2xl font-bold text-white mb-2" data-id="element-359">
                    🎁 Bono #4: 13 Checklists de Obra Completos para Imprimir
                  </h3>
                  <p className="text-stone-400 mb-4" data-id="element-360">
                    Un checklist por cada fase del proyecto, diseñados para
                    imprimir, pegar en el taller y tachar mientras construís.
                    Desde la compra del vehículo hasta el mantenimiento anual.
                    El sistema que garantiza que no se te olvida nada en ninguna
                    fase.
                  </p>
                  <p className="text-amber-400 font-medium mb-4" data-id="element-361">
                    Para que nunca tengas que desarmár algo porque olvidaste un
                    paso anterior.
                  </p>
                  <p className="font-bold text-white text-xl" data-id="element-362">¡GRATIS HOY!</p>
                </div>
              </div>
            </button>
          </div>
        </div>
      </section>

      {/* WHO THIS IS FOR */}
      <section className="py-20 px-4 bg-amber-500 text-stone-900" data-id="element-363">
        <div className="max-w-3xl mx-auto" data-id="element-364">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-10 text-center" data-id="element-365">
            ESTA GUÍA ES PARA VOS SI…
          </h2>
          <ul className="space-y-4 text-xl font-medium" data-id="element-366">
            <li className="flex items-start gap-4 bg-amber-400/30 p-4 rounded-xl" data-id="element-367">
              <CheckCircle2 className="w-7 h-7 flex-shrink-0 mt-0.5" data-id="element-368" />
              <span data-id="element-369">
                Tenés un furgón en el garaje y no sabés por dónde empezar.
              </span>
            </li>
            <li className="flex items-start gap-4 bg-amber-400/30 p-4 rounded-xl" data-id="element-370">
              <CheckCircle2 className="w-7 h-7 flex-shrink-0 mt-0.5" data-id="element-371" />
              <span data-id="element-372">
                Querés construir vos mismo para ahorrar el millón y medio que
                cobra un taller.
              </span>
            </li>
            <li className="flex items-start gap-4 bg-amber-400/30 p-4 rounded-xl" data-id="element-373">
              <CheckCircle2 className="w-7 h-7 flex-shrink-0 mt-0.5" data-id="element-374" />
              <span data-id="element-375">
                Le tenés miedo a la electricidad o al gas y necesitás que
                alguien te lo explique sin tecnicismos.
              </span>
            </li>
            <li className="flex items-start gap-4 bg-amber-400/30 p-4 rounded-xl" data-id="element-376">
              <CheckCircle2 className="w-7 h-7 flex-shrink-0 mt-0.5" data-id="element-377" />
              <span data-id="element-378">
                Querés que quede bien hecho, prolijo y con terminación de
                fábrica.
              </span>
            </li>
            <li className="flex items-start gap-4 bg-amber-400/30 p-4 rounded-xl" data-id="element-379">
              <CheckCircle2 className="w-7 h-7 flex-shrink-0 mt-0.5" data-id="element-380" />
              <span data-id="element-381">
                Necesitás homologarlo para circular legal y con seguro válido.
              </span>
            </li>
            <li className="flex items-start gap-4 bg-amber-400/30 p-4 rounded-xl" data-id="element-382">
              <CheckCircle2 className="w-7 h-7 flex-shrink-0 mt-0.5" data-id="element-383" />
              <span data-id="element-384">
                Planeás vivir en el motorhome y necesitás que todo funcione de
                verdad.
              </span>
            </li>
            <li className="flex items-start gap-4 bg-amber-400/30 p-4 rounded-xl" data-id="element-385">
              <CheckCircle2 className="w-7 h-7 flex-shrink-0 mt-0.5" data-id="element-386" />
              <span data-id="element-387">
                Viajás a destinos remotos y necesitás saber reparar fallas
                básicas sin depender de talleres.
              </span>
            </li>
          </ul>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-24 px-4 bg-stone-100" data-id="element-388">
        <div className="max-w-6xl mx-auto" data-id="element-389">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-16 text-center" data-id="element-390">
            LO QUE DICEN LOS QUE YA CONSTRUYERON
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-391">
            <TestimonialCard quote="Llevaba meses mirando videos sin avanzar. Con la guía, el primer fin de semana ya tenía el tratamiento anticorrosivo hecho y la aislación planificada. La diferencia entre tener un sistema y no tenerlo es brutal." name="Martín G." role="Constructor DIY" age="34" location="Buenos Aires" data-id="element-392" />
            <TestimonialCard quote="El sistema eléctrico siempre me daba miedo. La guía lo explica de una forma tan clara que hasta mi señora entendió. Instalamos todo nosotros solos y funciona perfecto desde el primer día." name="Diego R." role="Pareja viajera" age="41" location="Córdoba" data-id="element-393" />
            <TestimonialCard quote="Lo mejor es que todo está adaptado a Argentina. Precios reales, proveedores reales, normas reales. Sin tener que traducir nada ni adaptar nada a nuestra realidad." name="Laura M." role="Nómada digital" age="38" location="Mendoza" data-id="element-394" />
            <TestimonialCard quote="El capítulo de homologación me ahorró un desastre. El ingeniero vino, revisó todo y firmó sin pedirme ninguna modificación. Eso solo ya pagó la guía cien veces." name="Federico S." role="Constructor DIY" age="52" location="Rosario" data-id="element-395" />
            <div className="md:col-span-2 lg:col-span-1" data-id="element-396">
              <TestimonialCard quote="Soy familia con tres hijos y necesitaba que quedara seguro de verdad. La guía me dio la certeza de que cada decisión que tomé estaba respaldada por ingeniería real. El motorhome lleva dos años y todo funciona igual que el primer día." name="Sebastián V." role="Familia viajera" age="45" location="Santa Fe" data-id="element-397" />
            </div>
          </div>
        </div>
      </section>

      {/* PRICING & CHECKOUT SECTION */}
      <section id="purchase-section" className="py-24 px-4 bg-white scroll-mt-10" data-id="element-398">
        <div className="max-w-4xl mx-auto" data-id="element-399">
          <div className="bg-stone-900 rounded-3xl p-4 md:p-12 text-center relative overflow-hidden" data-id="element-400">
            <div className="absolute top-0 left-0 w-full bg-amber-500 text-stone-900 py-1.5 md:py-2 font-bold flex items-center justify-center gap-2 text-sm md:text-base" data-id="element-401">
              <Clock className="w-4 h-4 md:w-5 md:h-5" data-id="element-402" />
              EXPIRA EN: {formatTime(timeLeft.minutes)}:
              {formatTime(timeLeft.seconds)}
            </div>

            <div className="mt-8 md:mt-10 mb-4 md:mb-8" data-id="element-403">
              <h2 className="text-2xl md:text-4xl font-bold text-white mb-2 md:mb-4" data-id="element-404">
                Elegí tu <span className="text-cyan-400" data-id="element-405">PACK:</span>
              </h2>
              <p className="text-stone-300 text-sm md:text-lg" data-id="element-406">
                Todas las opciones incluyen los 4 bonos estratégicos
              </p>
            </div>

            <div className="space-y-3 md:space-y-4 max-w-3xl mx-auto mb-4 md:mb-8" data-id="element-407">
              {/* Opción 1: Guía Maestra */}
              <button onClick={() => setSelectedPack('guia')} className={`bg-stone-800 border-2 ${selectedPack === 'guia' ? 'border-cyan-400' : 'border-stone-700'} rounded-xl md:rounded-2xl p-3 md:p-6 text-left hover:border-cyan-400 transition-colors cursor-pointer block w-full`} data-id="element-408">
                <div className="flex items-center justify-between" data-id="element-409">
                  <div className="flex items-center gap-2 md:gap-4" data-id="element-410">
                    <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 ${selectedPack === 'guia' ? 'border-cyan-400 bg-cyan-400' : 'border-stone-500'} flex items-center justify-center`} data-id="element-411">
                      {selectedPack === 'guia' && <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-stone-900" data-id="element-412"></div>}
                    </div>
                    <div data-id="element-413">
                      <h3 className="text-base md:text-xl font-bold text-white" data-id="element-414">
                        📘 GUÍA MAESTRA
                      </h3>
                      <p className="text-stone-400 text-xs md:text-sm" data-id="element-415">
                        16 partes + 4 bonos
                      </p>
                    </div>
                  </div>
                  <div className="text-right" data-id="element-416">
                    <div className="text-xl md:text-3xl font-extrabold text-white" data-id="element-417">
                      $19.990
                    </div>
                  </div>
                </div>
              </button>

              {/* Opción 2: Pack Completo */}
              <button onClick={() => setSelectedPack('completo')} className={`bg-stone-800 border-2 ${selectedPack === 'completo' ? 'border-cyan-400' : 'border-stone-700'} rounded-xl md:rounded-2xl p-3 md:p-6 text-left relative block w-full hover:border-cyan-400 transition-colors cursor-pointer`} data-id="element-418">
                <div className="absolute -top-2 md:-top-3 left-1/2 -translate-x-1/2" data-id="element-419">
                  <span className="bg-cyan-400 text-stone-900 text-[10px] md:text-xs font-bold px-3 md:px-4 py-0.5 md:py-1 rounded-full uppercase" data-id="element-420">
                    ⭐ MÁS ELEGIDO
                  </span>
                </div>
                <div className="flex items-center justify-between mb-2 md:mb-4" data-id="element-421">
                  <div className="flex items-center gap-2 md:gap-4" data-id="element-422">
                    <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 ${selectedPack === 'completo' ? 'border-cyan-400 bg-cyan-400' : 'border-stone-500'} flex items-center justify-center`} data-id="element-423">
                      {selectedPack === 'completo' && <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-stone-900" data-id="element-424"></div>}
                    </div>
                    <div data-id="element-425">
                      <h3 className="text-base md:text-xl font-bold text-white" data-id="element-426">
                        🏆 PACK COMPLETO
                      </h3>
                      <p className="text-stone-400 text-xs md:text-sm" data-id="element-427">
                        Guía + 3 Recursos
                      </p>
                    </div>
                  </div>
                  <div className="text-right" data-id="element-428">
                    <div className="text-stone-500 line-through text-xs md:text-lg" data-id="element-429">
                      $50.000
                    </div>
                    <div className="text-xl md:text-3xl font-extrabold text-white" data-id="element-430">
                      $30.990
                    </div>
                  </div>
                </div>
                <div className="bg-stone-900 rounded-lg md:rounded-xl p-2 md:p-4 space-y-1.5 md:space-y-3 text-xs md:text-sm" data-id="element-431">
                  <div className="flex items-start gap-1.5 md:gap-2" data-id="element-432">
                    <CheckCircle2 className="w-3 h-3 md:w-4 md:h-4 text-cyan-400 flex-shrink-0 mt-0.5" data-id="element-433" />
                    <p className="text-stone-300" data-id="element-434">
                      <span className="font-bold text-white" data-id="element-435">
                        Planos Maestros:
                      </span>{' '}
                      Medidas reales (Sprinter/Master/Ducato) para construir sin
                      errores
                    </p>
                  </div>
                  <div className="flex items-start gap-1.5 md:gap-2" data-id="element-436">
                    <CheckCircle2 className="w-3 h-3 md:w-4 md:h-4 text-cyan-400 flex-shrink-0 mt-0.5" data-id="element-437" />
                    <p className="text-stone-300" data-id="element-438">
                      <span className="font-bold text-white" data-id="element-439">
                        Energía Solar:
                      </span>{' '}
                      Guía cable por cable con diagramas y configuración MPPT
                    </p>
                  </div>
                  <div className="flex items-start gap-1.5 md:gap-2" data-id="element-440">
                    <CheckCircle2 className="w-3 h-3 md:w-4 md:h-4 text-cyan-400 flex-shrink-0 mt-0.5" data-id="element-441" />
                    <p className="text-stone-300" data-id="element-442">
                      <span className="font-bold text-white" data-id="element-443">
                        Manual de Supervivencia:
                      </span>{' '}
                      Soluciones para fallas en ruta sin técnico
                    </p>
                  </div>
                </div>
              </button>
            </div>

            <a href={selectedPack === 'guia' ? 'https://campercheckout.ebookditales.com/cart/51932175696155:1' : 'https://campercheckout.ebookditales.com/cart/51932176613659:1'} className="bg-cyan-400 hover:bg-cyan-300 text-stone-900 text-base md:text-xl font-extrabold py-3 md:py-5 px-6 md:px-8 rounded-xl shadow-[0_6px_0_rgb(6,182,212)] md:shadow-[0_8px_0_rgb(6,182,212)] hover:shadow-[0_3px_0_rgb(6,182,212)] md:hover:shadow-[0_4px_0_rgb(6,182,212)] hover:translate-y-1 transition-all w-full max-w-lg mx-auto flex items-center justify-center gap-2" data-id="element-444">
              {selectedPack === 'guia' ? 'SÍ, QUIERO LA GUÍA MAESTRA →' : 'SÍ, QUIERO EL PACK COMPLETO →'}
            </a>

            <p className="text-stone-400 text-xs md:text-sm mt-2 md:mt-4" data-id="element-445">
              Podés sumar el otro nivel cuando quieras
            </p>

            <div className="mt-3 md:mt-6 flex items-center justify-center gap-2 text-stone-400 text-xs md:text-sm" data-id="element-446">
              <ShieldCheck className="w-3 h-3 md:w-4 md:h-4" data-id="element-447" /> Pago 100% seguro
              y encriptado
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 px-4 bg-stone-50" data-id="element-448">
        <div className="max-w-3xl mx-auto" data-id="element-449">
          <h2 className="text-3xl font-bold text-stone-900 mb-12 text-center" data-id="element-450">
            PREGUNTAS FRECUENTES
          </h2>

          <div className="space-y-6" data-id="element-451">
            <div className="bg-white p-6 rounded-2xl border border-stone-200" data-id="element-452">
              <h3 className="font-bold text-lg text-stone-900 mb-2" data-id="element-453">
                ¿En qué formato recibo la guía?
              </h3>
              <p className="text-stone-700" data-id="element-454">
                PDF descargable. Acceso inmediato después del pago. Podés leerlo
                desde el celular, tablet o computadora. También podés imprimirlo
                completo o por partes.
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl border border-stone-200" data-id="element-455">
              <h3 className="font-bold text-lg text-stone-900 mb-2" data-id="element-456">
                ¿Necesito conocimientos técnicos previos?
              </h3>
              <p className="text-stone-700" data-id="element-457">
                No. La guía está diseñada para personas sin experiencia en
                electricidad, plomería ni carpintería. Cada tema se explica
                desde cero con analogías simples y ejemplos prácticos.
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl border border-stone-200" data-id="element-458">
              <h3 className="font-bold text-lg text-stone-900 mb-2" data-id="element-459">
                ¿Para qué tipo de vehículo sirve?
              </h3>
              <p className="text-stone-700" data-id="element-460">
                Para furgones (Sprinter, Master, Ducato), minibuses y
                colectivos. Hay secciones específicas para cada tipo de vehículo
                con medidas y consideraciones propias.
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl border border-stone-200" data-id="element-461">
              <h3 className="font-bold text-lg text-stone-900 mb-2" data-id="element-462">
                ¿Los precios están actualizados?
              </h3>
              <p className="text-stone-700" data-id="element-463">
                Sí. Los precios de referencia están actualizados al mercado
                argentino 2024 en ARS y USD. Se actualizan periódicamente.
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl border border-stone-200" data-id="element-464">
              <h3 className="font-bold text-lg text-stone-900 mb-2" data-id="element-465">
                ¿Sirve si ya empecé el proyecto?
              </h3>
              <p className="text-stone-700" data-id="element-466">
                Sí. La guía está organizada en fases independientes. Podés
                entrar en cualquier punto del proyecto y seguir desde donde
                estás.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="py-20 px-4 bg-emerald-900 text-emerald-50" data-id="element-467">
        <div className="max-w-3xl mx-auto text-center" data-id="element-468">
          <ShieldCheck className="w-20 h-20 text-emerald-400 mx-auto mb-6" data-id="element-469" />
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-470">
            🛡️ GARANTÍA TOTAL 7 DÍAS
          </h2>

          <p className="text-xl mb-6" data-id="element-471">
            Usá la guía durante una semana completa.
          </p>
          <p className="text-lg mb-8" data-id="element-472">Si no sentís:</p>

          <ul className="space-y-4 text-left max-w-xl mx-auto mb-10 text-emerald-100" data-id="element-473">
            <li className="flex items-start gap-3" data-id="element-474">
              <CheckCircle2 className="w-6 h-6 text-emerald-400 flex-shrink-0 mt-0.5" data-id="element-475" />
              <span data-id="element-476">
                Más claridad sobre qué hacer en cada fase del proyecto
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-477">
              <CheckCircle2 className="w-6 h-6 text-emerald-400 flex-shrink-0 mt-0.5" data-id="element-478" />
              <span data-id="element-479">
                Menos miedo frente a la electricidad, el gas y la homologación
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-480">
              <CheckCircle2 className="w-6 h-6 text-emerald-400 flex-shrink-0 mt-0.5" data-id="element-481" />
              <span data-id="element-482">
                Un plan concreto para avanzar el próximo fin de semana sin
                adivinar nada
              </span>
            </li>
          </ul>

          <p className="text-2xl font-bold text-white mb-4" data-id="element-483">
            Te devolvemos el 100% del dinero.
          </p>
          <p className="text-emerald-300" data-id="element-484">
            Sin preguntas. Sin formularios. Sin vueltas.
          </p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-stone-950 text-stone-400 py-12 px-4 text-center text-sm" data-id="element-485">
        <div className="max-w-4xl mx-auto space-y-6" data-id="element-486">
          <div className="flex items-center justify-center gap-2 mb-8" data-id="element-487">
            <Download className="w-5 h-5 text-stone-500" data-id="element-488" />
            <span className="font-medium text-stone-300" data-id="element-489">PRODUCTO DIGITAL</span>
            <span className="hidden md:inline" data-id="element-490">·</span>
            <span className="hidden md:inline" data-id="element-491">
              Este producto es digital y se envía automáticamente después de la
              compra.
            </span>
          </div>
          <p className="md:hidden" data-id="element-492">
            Este producto es digital y se envía automáticamente después de la
            compra.
          </p>
          <p data-id="element-493">Acceso inmediato. Descarga en PDF. Acceso de por vida.</p>

          <div className="pt-8 border-t border-stone-800" data-id="element-494">
            <p className="mb-4" data-id="element-495">
              © 2024 Guía Maestra de Camperización Argentina. Todos los
              derechos reservados.
            </p>
            <div className="flex justify-center gap-4 mb-8" data-id="element-496">
              <a href="#" className="hover:text-stone-200 transition-colors" data-id="element-497">
                Términos y Condiciones
              </a>
              <span data-id="element-498">·</span>
              <a href="#" className="hover:text-stone-200 transition-colors" data-id="element-499">
                Política de Privacidad
              </a>
              <span data-id="element-500">·</span>
              <a href="#" className="hover:text-stone-200 transition-colors" data-id="element-501">
                Contacto
              </a>
            </div>

            <p className="text-xs text-stone-600 max-w-2xl mx-auto leading-relaxed" data-id="element-502">
              Este sitio no es parte del sitio web de Facebook o Facebook Inc.
              Además, este sitio NO está respaldado por Facebook de ninguna
              manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
            </p>
          </div>
        </div>
      </footer>
    </div>;
}